function SectionFaqPayments() {
    return (
        <>
            <div className="tw-faq-section">
                <div className="accordion tw-faq" id="sf-faq-accordion-3">
                    {/*one*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ1-3" aria-expanded="false">
                            What Makes Your Business Plans So Special?
                        </button>
                        <div id="FAQ1-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*two*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ2-3" aria-expanded="false">
                            Reset Password With Phone Number?
                        </button>
                        <div id="FAQ2-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*three*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ3-3" aria-expanded="false">
                            How do I redeem a coupon?
                        </button>
                        <div id="FAQ3-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*four*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ4-3" aria-expanded="false">
                            How long will it take to post my job?
                        </button>
                        <div id="FAQ4-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*five*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ5-3" aria-expanded="false">
                            What is your cancellation policy?
                        </button>
                        <div id="FAQ5-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*six*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ6-3" aria-expanded="false">
                            Where Can I Find Market Research Reports?
                        </button>
                        <div id="FAQ6-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*seven*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ7-3" aria-expanded="false">
                            Do I need to know PHP to use TheJobs?
                        </button>
                        <div id="FAQ7-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*eight*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ8-3" aria-expanded="false">
                            How soon will I start receiving resumes?
                        </button>
                        <div id="FAQ8-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionFaqPayments;